import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    campaignList: [],
    campaignArr: [],
    campaignArray: [],
    campaignID: "",
    selectedCampaign: null,
    selectedChannel: [],
    channelName: "",
    selectedAsset: [],
    selectedMetric: [],
    selectedRoi: [],
    isEditing: "",
  };
  
  const mutations = {
    initializeStore(state){
      state.campaignList = [];
      state.campaignArr = [];
      state.campaignArray = [];
      state.campaignID = '';
      state.selectedCampaign = null;
      state.selectedChannel = null;
      state.channelName = "";
      state.selectedAsset = null;
      state.selectedMetric = null;
      state.selectedRoi = null;
      state.isEditing = false;
    },
    SET_SELECTED_CAMPAIGN(state, campaign) {
      state.selectedCampaign = campaign;
      state.isEditing = true;
    },
    SET_SELECTED_CHANNEL(state, channel) {
      state.selectedChannel = channel;
    },
    SETTED_SELECTED_ASSET(state, asset) {
      state.selectedAsset = asset;
    },
    SETTED_SELECTED_METRIC(state, metric) {
      state.selectedMetric = metric;
    },
    SETTED_SELECTED_ROI(state, roi) {
      state.selectedRoi = roi;
    },
    CAMPAIGNS_ARRAY(state, campaigns){
      state.campaignArray = campaigns;
    },
    LIST_MARKETING_CAMPAIGNS(state, campaigns) {
      state.campaignList = campaigns;
    },
    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){
        
      }
    },
    RESET_SEARCH_FILTERS(state){
      
    }

  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },
    
    async createMarketingCampaign({ commit,state }, formData) {
      return axios.post('api/v1/create-marketing-campaign/', formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })
    },
  
    fetchMarketingCampaigns({ commit,state }, formData) {
      state.campaignArr = [];
      axios.post(`api/v1/get-marketing-campaigns/`,formData)
      .then((response)=>{
        for(let i=0; i< response.data.length; i++){
          state.campaignArr.push((response.data[i].name));
        }
        commit('LIST_MARKETING_CAMPAIGNS', response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    fetchMarketingCampaign({ commit,state }, formData) {
      axios.post(`api/v1/get-marketing-campaigns/`,formData)
      .then((response)=>{
        state.selectedCampaign = response.data;
        commit('SET_SELECTED_CAMPAIGN',response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    async fetchMarketingChannel({ commit,state }, formData) {
      return axios.post(`api/v1/get-campaign-channels/`,formData)
      .then((response)=>{
        state.selectedChannel = response.data;
        state.channelName = response.data.channel.name;
        commit('SET_SELECTED_CHANNEL',response.data);
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })
      
    },
    fetchMarketingAsset({ commit,state }, formData) {
      axios.post(`api/v1/get-campaign-assets/`,formData)
      .then((response)=>{
        state.selectedAsset = response.data;
        commit('SET_SELECTED_ASSET',response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    fetchMarketingMetric({ commit,state }, formData) {
      axios.post(`api/v1/get-campaign-metrics/`,formData)
      .then((response)=>{
        state.selectedAsset = response.data;
        commit('SET_SELECTED_METRIC',response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    fetchMarketingRoi({ commit,state }, formData) {
      axios.post(`api/v1/get-campaign-rois/`,formData)
      .then((response)=>{
        state.selectedAsset = response.data;
        commit('SET_SELECTED_ROI',response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    handleSelectedCampaign({ commit, state }, option){
      state.campaignArray = [];
      const selectedCampaign = state.campaignList.find(campaign => (campaign.name) === option);
      if (selectedCampaign) {
          state.campaignID = selectedCampaign.campaign_id;
          state.campaignArray = [...state.campaignArray, selectedCampaign];
      }
      commit('CAMPAIGNS_ARRAY', state.campaignArray);
        
    },
  
    async updateMarketingCampaign({ commit,state }, formData) {
      return axios.put(`api/v1/update-marketing-campaign/`,formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })  
    },
  
    deleteMarketingCampaign({ commit,state }, formData) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you wish to delete Campaign?`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes Delete Campaign!',
        cancelButtonText: 'Cancel!',
        customClass: {
            confirmButton: 'swal2-confirm-custom',
            cancelButton: 'swal2-cancel-custom',
        },
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          axios.post(`api/v1/delete-marketing-campaign/`,formData)
          .then((response)=>{
            if(response.status == 200){
                Swal.fire("Poof! Campaign removed succesfully!", {
                  icon: "success",
                }); 
            }else{
              Swal.fire({
                title: "Error Deleting Campaign",
                icon: "warning",
              });
            }                   
          })
          .catch((error)=>{
            console.log(error.message);
            Swal.fire({
              title: error.message,
              icon: "warning",
            });
          })
        }else{
          Swal.fire(`Campaign has not been deleted!`);
        }
      })
    },
  };
  
  const getters = {
    // users: (state) => state.users,
    // currentUser: (state) => state.currentUser,
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  